import styled from "styled-components";

export const DateTimeStyled = styled.div`
  .label {
    margin-bottom: 2px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    span {
      color: ${({ theme }) => theme.COLORS.RED_1};
    }
  }
  .input {
    width: 100%;
    .react-datetime-picker__wrapper {
      border-radius: 21px;
      border: ${({ isError }) => (isError ? "1px" : "0.5px")} solid
        ${({ theme, isError }) =>
          isError ? theme.COLORS.RED_1 : theme.COLORS.PURPLE_1};
      padding: 0 15px;
      width: 100%;
      height: 42px;
      background: transparent;
      text-align: left;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .input_calendar {
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      .react-calendar__navigation__label {
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }
  }
  .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  &.calendar_top {
    position: relative;
    .react-datetime-picker__calendar {
      position: absolute !important;
      bottom: 100% !important;
      top: auto !important;
      left: 0 !important;
      z-index: 1000;
      margin-bottom: 4px;
    }
    .react-datetime-picker__calendar--open {
      transform: none !important;
    }
  }

  .theme_standard {
  }

  &.theme_bosendorfer {
    .input {
      .react-datetime-picker__wrapper {
        border-radius: 0px;
        border: 1px solid ${({ theme }) => theme.COLORS.GOLD_1};
        color: ${({ theme }) => theme.COLORS.GOLD_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.BRANDON_REGULAR};
      }
    }
  }
`;
